module.exports = __webpack_public_path__ + "static/media/img2.8d8cdf59.jpg";